/** biome-ignore-all lint/style/useNamingConvention: Naming convention from backend */
// biome-ignore lint/style/noEnum: Consistent way of handling strings
export enum BankIdStatus {
  Untouched = "untouched",
  Pending = "pending",
  Failed = "failed",
  Cancelled = "cancelled",
  Timeout = "timeout",
  Complete = "complete",
}

export type CloseModalProps = {
  closeModal: () => void;
};
